


























































import { defineComponent, ref, useFetch, useContext } from '@nuxtjs/composition-api'
import axios from 'axios';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import { appendStylesFromText, getAxiosConfigs } from '~/utils/solepro/functions';
import { getProductTopicBgColor, getProductTypeTag } from '~/utils/solepro/products';
import { addBasePath } from "~/helpers/addBasePath";
import "swiper/swiper-bundle.css";
import { Pagination, Autoplay } from "swiper";
import { AutoplayOptions } from 'swiper/types/components/autoplay';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { useConfig } from '~/composables';
import { promoBannerButtonTrack } from '~/helpers/trackings/24orepro/home';
import Spinner from '~/components/solepro/Spinner.vue';

SwiperCore.use([Pagination, Autoplay])

export default defineComponent({
    data() {
        return {
            activeIndex: 0
        }
    },
    props: {
        content: {
            type: String,
            default: '',
        }
    },
    components: {
        Swiper, SwiperSlide,
        Spinner
    },
    setup(props, {emit}) {
        const { content } = props;
        const getContentTree = () => getAsJSON(content);
        const contentTree = getContentTree()
        const products = ref([])
        const skus = ref([])
        const autoplay = ref(null)
        const allCategories = ref([]);
        const categoryStore = useCategoryStore()
        const { config } = useConfig();
        const { app } = useContext();
        

        try {
            const productsCarousel = contentTree.children[0].children[0];
            skus.value = productsCarousel.skus;
            autoplay.value = productsCarousel.autoplay == 'true' ? productsCarousel.autoplaySpeed : null;

        } catch (e) {
            console.warn('PromoBanner: no products found')
        }
        const swiperProps = {
            loop: !!autoplay.value,
            slidesPerView: 1,
            loopedSlides: 1,
            slideClass: "swiper-slide",
            autoplay: {
                enabled: !!autoplay.value,
                delay: +autoplay.value,
            } as AutoplayOptions,
            spaceBetween: 12,
            pagination: true
        }

        const canInitSwiper = ref(false);

        useFetch(async () => {
            emit('start');
            const { data } = await axios.post('/sole-api/product/pro/getProductsDatasForBanner', { skus: skus.value }, {
                ...getAxiosConfigs(app, config)
            })
            products.value = data;
            categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children
            products.value.forEach((p, index) => {
                products.value[index].productTypeTag = getProductTypeTag(allCategories.value, p)
                products.value[index].topicColor = getProductTopicBgColor(allCategories.value, p)
            })
            canInitSwiper.value = true;
            emit('loaded')
        })


        return {
            products,
            autoplay,
            addBasePath,
            swiperProps,
            canInitSwiper,
            storeCode : config.value.store_code,
            contentTree,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
    mounted(){
        if (this.contentTree.pageBuilderStyleNode) appendStylesFromText(this.contentTree.pageBuilderStyleNode)

    },
    methods: {
        trackPromoButton(val) {
            promoBannerButtonTrack(val)
        },
        updateTextAndAnimateHeight(element, newText) {
            element.innerHTML = newText;
            element.style.height = `auto`;
            const newHeight = element.offsetHeight;
            

            // Forza il reflow per attivare la transizione
            setTimeout(() => {
                element.style.height = `${newHeight}px`;
            }, 0);

            // Ripristina l'altezza automatica alla fine della transizione
            element.addEventListener(
                "transitionend",
                function () {
                    element.style.height = `auto`;
                },
                { once: true }
            );
        },
        updateBulletTimer(swiper) {
            const previousIndex = swiper.previousRealIndex;
            const currentIndex = swiper.realIndex;
            const lastIndex = swiper.slides.length - 1;
            const isLoopToFirst = previousIndex === lastIndex && currentIndex === 0;
            const isLoopToLast = previousIndex === 0 && currentIndex === lastIndex;
            if (!swiper.pagination.bullets) return;
            if (swiper.pagination.bullets.length) {
                if (isLoopToFirst || isLoopToLast) {
                    swiper.pagination.bullets.forEach((bullet) => {
                        this.handleTimerBulletAnimation(bullet, isLoopToFirst ? false : true);
                    })
                }
                swiper.pagination.bullets.forEach((bullet, index) => {
                    if (index == parseInt(currentIndex)-1) {
                        this.addAnimation(bullet, swiper.params.autoplay.delay)
                    } else if (index < parseInt(currentIndex)-1) {
                        this.handleTimerBulletAnimation(bullet, true)
                    } else {
                        this.handleTimerBulletAnimation(bullet, false)
                    }

                })
            }

        },
        handleTimerBulletAnimation(bullet, addClass) {
            if (addClass) {
                bullet.classList.add('prev');
            } else {
                bullet.classList.remove('prev');
            }
            bullet.offsetHeight;
            bullet.querySelector(".bullet-timer").style.animation = null;
        },
        addAnimation(bullet, delay) {
            const currentBulletTimer = bullet.querySelector(".bullet-timer");
            currentBulletTimer.style.animation = `progress ${delay}ms linear forwards`;
        },
        beforeTransitionStart(swiper) {
            const textContainer = this.$el.querySelector(".text-container") as HTMLElement;
            const slides = swiper.$el[0].querySelectorAll('.swiper-slide');
            const activeSlide = slides[swiper.activeIndex] as HTMLElement;
            if (!textContainer || !activeSlide) return;
            const productDatas = activeSlide.querySelector('.product-datas') as HTMLElement;
            const titleContainer = textContainer.querySelector('.title-container .title');
            const pContainer = textContainer.querySelector('.title-container .description');
            this.updateTextAndAnimateHeight(titleContainer, productDatas.dataset.title)
            this.updateTextAndAnimateHeight(pContainer, productDatas.dataset.description)
        },
        afterInit(swiper) {
            const bulletTimer = document.createElement('span');
            bulletTimer.classList.add('bullet-timer')
            swiper.pagination.bullets.forEach(el => {
                el.classList.add('relative')
                el.classList.add('overflow-hidden')
                el.appendChild(bulletTimer.cloneNode())
            });
            this.updateBulletTimer(swiper)
        },
        slideChange(swiper) {
            const textContainer = this.$el.querySelector(".text-container") as HTMLElement;
            const activeSlide = swiper.slides[swiper.activeIndex] as HTMLElement;
            if (!activeSlide) return;
            const productDatas = activeSlide.querySelector('.product-datas') as HTMLElement;
            this.activeIndex = parseInt(productDatas.dataset.index);
            const cta = textContainer.querySelector('.cta') as HTMLElement;
            if (cta) {
                cta.innerHTML = productDatas.dataset.ctaLabel;
                cta.setAttribute('href', productDatas.dataset.ctaLink);
            }

            this.updateBulletTimer(swiper)
        },
        getRealIndex(swiper) {
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-real-index') : 0;
        },
        getPreviousRealIndex(swiper) {
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            if (swiper.realIndex > swiper.previousIndex) { // going next
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-prev-index') : 0;
            } else { //going backwards
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-next-index') : 0;
            }
        }

    }
    /* beforeDestroy(){
       this.getContentTree.clear(); /** Avoid memory leak for storing all the content tree * /
     }*/
});
